import './refresh/refresh';
import refineCompoonents from './refine-components';
import searchResults from './search-results/searchResults';

import searchService from './search-service/searchService';

const module = angular.module('websked.search', [
  'websked.refresh'
]);

const toLoad = [
  searchService,
  refineCompoonents,
  searchResults
];

toLoad.forEach(fn => fn(module));
